/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { DetailedUser, Pagination } from "../../../utils/Interfaces";

export interface UserManagementState {
    existingUsers: DetailedUser[];
    existingUsersCount: number;
}

const initialState: UserManagementState = {
    existingUsers: [],
    existingUsersCount: 0,
};

export const userManagementSlice = createSlice({
    name: "userManagement",
    initialState,
    reducers: {
        setExistingUsers: (state, action: PayloadAction<Pagination<DetailedUser>>) => {
            state.existingUsers = action.payload.results;
            state.existingUsersCount = action.payload.count;
        },
    },
});

export const { setExistingUsers } = userManagementSlice.actions;
export const selectExistingUsers = (state: RootState) => state.userManagement.existingUsers;
export const selectExistingUsersCount = (state: RootState) => state.userManagement.existingUsersCount;

export default userManagementSlice.reducer;
